// extracted by mini-css-extract-plugin
export default {"ball":"DotBall_ball__X5IJI","confirm":"DotBall_confirm__B1a4X","pending":"DotBall_pending__gGlI6","cancelled":"DotBall_cancelled__iybwj","completed":"DotBall_completed__0syqT"};